/**
 * Coarse device classification for analytics — same breakpoints Product.js already uses for
 * its mobile layout (<=768) so "mobile" here means the same thing it means everywhere else in
 * the app, plus a tablet band so 768-1024 doesn't get lumped into either bucket.
 */
export function getDeviceType() {
  if (typeof window === 'undefined') return 'unknown';
  const width = window.innerWidth;
  if (width <= 768) return 'mobile';
  if (width <= 1024) return 'tablet';
  return 'desktop';
}
